import { Controller } from "@hotwired/stimulus"
import axios from "axios"

export default class extends Controller {
  static targets = ["list", "input"]
  static values = {
    parentUrl: String,
    url: String
  }

  connect() {
    // ukryj sekcję dashboardową gdy lista TODO jest pusta
    this.observer = new MutationObserver(() => this.checkEmpty())
    this.observer.observe(this.listTarget, { childList: true })
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  // ukrywa dashboard-todo-section gdy lista jest pusta
  checkEmpty() {
    const section = document.getElementById("dashboard-todo-section")
    if (!section) return
    if (this.listTarget.children.length === 0) {
      section.classList.add("hidden")
    }
  }

  checkBoxChanged(event) {
    const url = event.target.dataset.url
    console.log(url)
    axios.patch(url, JSON.stringify({
      todo: {
        closed: event.target.checked
      }
    }), {
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
  }

  // potwierdzenie usunięcia tylko dla niezaznaczonych (otwartych) TODO
  confirmDelete(event) {
    const li = event.target.closest("li")
    const checkbox = li?.querySelector("input[type=checkbox]")
    if (checkbox && !checkbox.checked) {
      const message = event.params.confirmMessage
      if (!confirm(message)) {
        event.preventDefault()
      }
    }
  }

  addTodo(_event) {
    // dajemy chwile turbo do przetworzenia formularza
    setTimeout(() => {
      this.inputTarget.value = ""
    }, 100)
  }
}
